import { GraphQLClient } from 'graphql-request';

const graphQLClient = new GraphQLClient(
  process.env.NEXT_PUBLIC_API_URL + '/graphql'
);

export default graphQLClient;
